export default __webpack_public_path__ + "static/media/connection-animation-2.32e6c30e.gif";